
  import {defineComponent} from 'vue';
  import paycoUtils from "@/assets/js/utils";
  import ToTopComponent from "@/components/shared/TopButtonComponent.vue";
  import RecentSearchWordComponent from "@/components/search/RecentSearchWordComponent.vue";
  import NoSearchResultComponent from "@/components/search/NoSearchResultComponent.vue";
  import SearchResultComponent from "@/components/search/SearchResultComponent.vue";
  import Product from "@/domain/product/Product";
  import * as _ from "lodash";
  import SearchProductRequest from "@/domain/request/SearchProductRequest";
  import api from "@/api/backend-api";
  import {mapGetters, mapMutations} from "vuex";
  import DeleteRecentSearchWordRequest from "@/domain/request/DeleteRecentSearchWordRequest";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {SortOption} from "@/domain/sort/SortOption";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import store from "@/store";
  export default defineComponent({
    name: 'SearchView',
    components: {
      HeaderComponent,
      RecentSearchWordComponent,
      NoSearchResultComponent,
      SearchResultComponent,
      ToTopComponent
    },
    data() {
      return {
        recentSearchWordList: [] as Array<string>,
        searchWord: '',
        isTypingMode: false,

        page : 1,
        perPage: 20,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        debouncedScrollEvent: () => {return},

        totalCount: 0 as number,
        products:[] as Array<Product>
      }
    },
    created() {
      if (this.hasLogined) {
        this.getRecentSearchWordList();
      }

      this.initSortOption(new Array<SortOption> (
          new SortOption("POPULARITY", "인기순", true),
          new SortOption("HIGH_PRICE", "고가순", false),
          new SortOption("LOW_PRICE", "저가순", false),
          new SortOption("PRODUCT_NAME", "상품명순", false)
      ));
    },
    mounted() {
      this.debouncedScrollEvent = _.debounce(this.infiniteScrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);

      this.searchWord = this.$route.query.query as string;
      this.setSortOptionByString(this.$route.query.sort);

      this.loadNewSearchResult();
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    methods: {
      focusSearchInputArea(): void {
        (this.$refs.searchInputArea as HTMLElement).focus();
      },
      setSearchWord(searchWord: string): void {
        this.searchWord = paycoUtils.removeCharacterExceptKorEngNum(searchWord);
      },
      inputSearchWord(event: Event): void {
        const searchWord = (event.currentTarget as HTMLInputElement).value;
        this.setSearchWord(searchWord);
      },
      moveToPreviousPage(): void {
        router.back();
      },
      clickRecentSearchWord(recentSearchWord: string): void {
        this.setSearchWord(recentSearchWord);
        this.getSearchResult();
      },
      deleteRecentSearchWord(deleteAllYn: string, keyword: string): void {
        const request = new DeleteRecentSearchWordRequest(deleteAllYn, keyword);
        api.deleteRecentSearchWord(request)
        .then(response => {
          // console.log(response);
          this.getRecentSearchWordList();
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      setTypingMode(typingMode: boolean): void {
        this.isTypingMode = typingMode;
      },
      eraseSearchWord(): void {
        this.searchWord = '';
        this.focusSearchInputArea();
      },
      getRecentSearchWordList(): void {
        api.getRecentSearchWord()
        .then(response => {
          console.log(response);
          // token 및 phoneNumber가 정상적이지 않아 최근검색어 데이터를 못가져오는 경우
          if (response.data.result === null) {
            store.commit('MemberStore/removeMemberAuthData');
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('SearchResultView', {}, {query: this.searchWord, sort: this.getSortOptionValue}));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          this.recentSearchWordList = response.data.result.map(recentSearchWord => recentSearchWord);
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      infiniteScrollEvent(): void {
        const targetElement = document.getElementById("app");
        if (targetElement === undefined) {
          return;
        }

        const heightOfElement: number = targetElement!.scrollHeight;
        const topOfElement: number = window.scrollY;
        const clientHeightOfElement: number = targetElement!.clientHeight;
        const bottomOffset = 100;

        if (heightOfElement <= topOfElement + clientHeightOfElement + bottomOffset) {
          this.loadMoreSearchResult();
        }
      },
      getSearchResult(): void {
        this.updateUrlQuery();
        this.loadNewSearchResult();
      },
      updateUrlQuery(): void {
        router.replace(new NamedRouting('SearchResultView', {}, {query: this.searchWord, sort: this.getSortOptionValue}));
      },
      loadNewSearchResult(): void {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page = 1;
        this.hasMorePage = true;

        const sortBy = this.getSortOptionValue;
        const request = new SearchProductRequest(this.page, this.perPage, this.searchWord, sortBy);

        api.searchProduct(request)
        .then(response => {
          // console.log(response);
          this.totalCount = response.data.result.totalCount;
          this.products = response.data.result.productList.map(product => new Product(product));

          if (response.data.result.productList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .then(() => {
          if (this.hasLogined) {
            this.getRecentSearchWordList();
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;

          this.setTypingMode(false);
          (this.$refs.searchInputArea as HTMLElement).blur();
        });
      },
      loadMoreSearchResult(): void {
        if (!this.hasMorePage || this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page += 1;

        const sortBy = this.getSortOptionValue;
        const request = new SearchProductRequest(this.page, this.perPage, this.searchWord, sortBy);

        api.searchProduct(request)
        .then(response => {
          // console.log(response);
          this.totalCount = response.data.result.totalCount;
          response.data.result.productList.forEach(product => {
            this.products.push(new Product(product));
          });

          if (response.data.result.productList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      ...mapMutations('SortOptionStore', [
          'initSortOption',
          'setSortOptionByString',
      ]),
    },
    computed: {
      hasRecentSearchWordList(): boolean {
        return this.recentSearchWordList.length > 0;
      },
      hasSearchWord(): boolean {
        return this.searchWord.length > 0;
      },
      hasSearchResult(): boolean {
        return this.products.length > 0;
      },
      ...mapGetters('SortOptionStore', [
        'getSortOptionValue'
      ]),
      ...mapGetters('MemberStore', [
        'hasLogined'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
  });


